import styled, {DefaultTheme, css} from 'styled-components'

export const StyledTooltipWrapper = styled.div`
    ${({theme: {spacing}}) => css`
        padding: ${spacing / 2}px ${spacing}px;
        max-width: 350px;
    `}
`

export const StyledTooltipItem = styled.div`
    ${({
        theme: {spacing, palette, typography},
        withBorder = false,
        isFillBlack = false
    }: {
        theme: DefaultTheme
        withBorder?: boolean
        isFillBlack?: boolean
    }) => css`
        border-bottom: ${withBorder ? `1px solid ${palette.neutral[600]}` : 'none'};
        padding: ${spacing}px;
        cursor: pointer;
        display: flex;
        align-items: center;
        & span {
            font-weight: 400;
            ${typography.textSm}
            margin-left: ${spacing * 0.75}px;
            color: ${palette.primary[900]};
        }
        & svg {
            width: 24px;
            height: 20px;
            ${isFillBlack
                ? `
                & path {
                    fill: ${palette.neutral.black};
                }
            `
                : ''}
        }
    `}
`

export const StyledHostTooltipItem = styled(StyledTooltipItem)`
    ${({theme: {spacing}}: {theme: DefaultTheme}) => css`
        padding: ${spacing * 0.75}px;
        & span {
            line-height: 160%;
        }
    `}
`

export const StyledHasEverPaidText = styled.p`
    ${({theme: {typography, spacing}}: {theme: DefaultTheme}) => css`
        padding: ${spacing / 4}px;
        ${typography.textXs}
        text-align: center;
    `}
`
